// The serializable input struct. Same shape for human and AI.
// Wire-friendly: tiny, no references, all numeric.

// Plain enum (not const) so `isolatedModules` is happy.
// Single Punch / Grab buttons — Character.ts alternates punching arms under
// a held Punch, and Grab engages both arms while held.
export enum InputBtn {
  Punch = 1 << 0,
  // Synthetic "keepalive" tag — set by ColyseusTransport when it injects a
  // micro-tap input to break a character out of an idle settle pose (Rapier
  // auto-sleep / FP solver drift on repeated identical zero inputs). Carried
  // through the normal sim path so rollback replays it identically; nothing
  // in Character.ts branches on this bit so it has no gameplay effect — it's
  // purely a marker for telemetry on the receiving end.
  Keepalive = 1 << 1,
  Jump = 1 << 2,
  Grab = 1 << 3,
  Sprint = 1 << 5,
  JumpKick = 1 << 6,
  // Optional KBM-only "throw" backup — only meaningful while double-handing
  // a victim. Lets trackpad users who can't do RMB+LMB simultaneously
  // trigger the throw without re-binding everything else. On controller +
  // touch, throw stays mapped to the regular Punch button (it gets
  // re-purposed by Character.ts during a double-hold).
  Throw = 1 << 7
}

export interface InputFrame {
  tick: number;     // simulation tick
  moveX: number;    // -1..1 (strafe)
  moveZ: number;    // -1..1 (forward)
  aimYaw: number;   // radians, world space
  buttons: number;  // bitmask of InputBtn
}

export function emptyInput(tick = 0): InputFrame {
  return { tick, moveX: 0, moveZ: 0, aimYaw: 0, buttons: 0 };
}

export function btn(frame: InputFrame, b: InputBtn): boolean {
  return (frame.buttons & b) !== 0;
}

export function setBtn(frame: InputFrame, b: InputBtn, on: boolean): void {
  if (on) frame.buttons |= b;
  else frame.buttons &= ~b;
}
